
module.exports = function getResource(label, vars = []) {
    const resources = { backToLists: 'Retourner aux listes' };
    return resources[label];
};
